import { render, staticRenderFns } from "./frc.vue?vue&type=template&id=b9d43f84&scoped=true"
import script from "./frc.vue?vue&type=script&lang=js"
export * from "./frc.vue?vue&type=script&lang=js"
import style0 from "./frc.vue?vue&type=style&index=0&id=b9d43f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d43f84",
  null
  
)

export default component.exports